module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main